// global
import React from 'react';
import PropTypes from 'prop-types';
//components
import { Form } from 'semantic-ui-react';
// stylesheets
import styles from './PageFilter.module.scss';

function PageFilter(props) {
  const { children } = props;

  const leftWrapper = React.Children.toArray(children).find(
    child => child.type === PageFilter.Left
  );
  const rightWrapper = React.Children.toArray(children).find(
    child => child.type === PageFilter.Right
  );

  const left = leftWrapper ? React.Children.toArray(leftWrapper.props.children) : [];
  const right = rightWrapper ? React.Children.toArray(rightWrapper.props.children) : [];

  return (
    <div className={styles.filterContainer}>
      <Form style={{ margin: '20px' }}>
        <Form.Group style={{ flexWrap: 'wrap' }}>
          {left.map((c, i) => (
            <Form.Field key={c.key || i}>{c}</Form.Field>
          ))}

          <Form.Group style={{ marginLeft: 'auto', alignItems: 'flex-end', marginBottom: 0 }}>
            {right.map((c, i) => (
              <Form.Field key={c.key || i}>{c}</Form.Field>
            ))}
          </Form.Group>
        </Form.Group>
      </Form>
    </div>
  );
}
/* eslint-disable-next-line */
function Left({ children }) {
  return <>{children}</>;
}
/* eslint-disable-next-line */
function Right({ children }) {
  return <>{children}</>;
}

PageFilter.Left = Left;
PageFilter.Right = Right;

PageFilter.propTypes = {
  children: PropTypes.node
};
export default PageFilter;
